var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTodayIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "performance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M32 44H28V40H20V44H16C14.896 44 14 44.896 14 46C14 47.104 14.896 48 16 48H32C33.106 48 34 47.104 34 46C34 44.896 33.106 44 32 44Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M44.5 8H33.7C33.9 8.94 34 9.92 34 10.88V12H44V36H4V12H14V10.88C14 9.92 14.1 8.94 14.3 8H3.5C1.58 8 0 9.58 0 11.5V36.5C0 38.42 1.58 40 3.5 40H44.5C46.42 40 48 38.42 48 36.5V11.5C48 9.58 46.42 8 44.5 8Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M33 25.978H15C14.448 25.978 14 25.53 14 24.978V22.636C14 21.3 14.52 20.044 15.464 19.1L18 16.564V10.88C18 8.46598 18.81 6.08398 20.282 4.17198L23.208 0.369977C23.586 -0.122023 24.416 -0.122023 24.794 0.369977L27.72 4.17398C29.19 6.08398 30 8.46598 30 10.88V16.564L32.536 19.1C33.48 20.044 34 21.3 34 22.636V24.978C34 25.532 33.552 25.978 33 25.978Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M29 29.978C27.894 29.978 27 29.082 27 27.978V24.978C27 23.874 27.894 22.978 29 22.978C30.106 22.978 31 23.874 31 24.978V27.978C31 29.084 30.106 29.978 29 29.978Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M19 29.978C17.894 29.978 17 29.082 17 27.978V24.978C17 23.874 17.894 22.978 19 22.978C20.106 22.978 21 23.874 21 24.978V27.978C21 29.084 20.106 29.978 19 29.978Z",
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTodayIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/todayIcon.89deb871c63c8432234211f5bdc38dd0.svg";